module.exports = __webpack_public_path__ + "img/copper-ore.05a16051.png";